const OPTIMIZATION_FINDINGS_PANEL_CONSTANTS = {
  IMPACT: 'Impact:',
  EFFORT: 'Effort:',
  CONFIDENCE: 'Confidence:',
  PERCENT: '%',
  SAVI_ANALYSIS: 'Savi Analysis',
  CLOSE: 'Close',
  REVIEW_LIST: 'Review List',
  DEPROVISION_ALL: 'Deprovision All',
  LICENSE_SAVINGS: 'LICENSE SAVINGS',
} as const;

export default OPTIMIZATION_FINDINGS_PANEL_CONSTANTS;
